import ApiLog from './Index.vue'

ApiLog.install = function(Vue) {
  Vue.component(ApiLog.name, ApiLog)
}

export { ApiLog }
